/**
 * 星座計算工具
 * 根據出生年月日計算星座、年齡、以及判斷是否為今日壽星
 */

const ZODIAC_SIGNS = [
    { name: '摩羯座', emoji: '♑', startMonth: 12, startDay: 22, endMonth: 1, endDay: 19 },
    { name: '水瓶座', emoji: '♒', startMonth: 1, startDay: 20, endMonth: 2, endDay: 18 },
    { name: '雙魚座', emoji: '♓', startMonth: 2, startDay: 19, endMonth: 3, endDay: 20 },
    { name: '牡羊座', emoji: '♈', startMonth: 3, startDay: 21, endMonth: 4, endDay: 19 },
    { name: '金牛座', emoji: '♉', startMonth: 4, startDay: 20, endMonth: 5, endDay: 20 },
    { name: '雙子座', emoji: '♊', startMonth: 5, startDay: 21, endMonth: 6, endDay: 21 },
    { name: '巨蟹座', emoji: '♋', startMonth: 6, startDay: 22, endMonth: 7, endDay: 22 },
    { name: '獅子座', emoji: '♌', startMonth: 7, startDay: 23, endMonth: 8, endDay: 22 },
    { name: '處女座', emoji: '♍', startMonth: 8, startDay: 23, endMonth: 9, endDay: 22 },
    { name: '天秤座', emoji: '♎', startMonth: 9, startDay: 23, endMonth: 10, endDay: 23 },
    { name: '天蠍座', emoji: '♏', startMonth: 10, startDay: 24, endMonth: 11, endDay: 21 },
    { name: '射手座', emoji: '♐', startMonth: 11, startDay: 22, endMonth: 12, endDay: 21 },
];

/**
 * 根據生日取得星座
 * @param {string} birthday - 格式 'YYYY-MM-DD'
 * @returns {{ name: string, emoji: string } | null}
 */
export function getZodiacSign(birthday) {
    if (!birthday) return null;
    const date = new Date(birthday);
    if (isNaN(date.getTime())) return null;

    const month = date.getMonth() + 1; // 1-12
    const day = date.getDate();

    for (const sign of ZODIAC_SIGNS) {
        if (sign.startMonth === 12 && sign.endMonth === 1) {
            // 摩羯座跨年
            if ((month === 12 && day >= sign.startDay) || (month === 1 && day <= sign.endDay)) {
                return { name: sign.name, emoji: sign.emoji };
            }
        } else {
            if (
                (month === sign.startMonth && day >= sign.startDay) ||
                (month === sign.endMonth && day <= sign.endDay)
            ) {
                return { name: sign.name, emoji: sign.emoji };
            }
        }
    }
    return null;
}

/**
 * 根據生日計算年齡
 * @param {string} birthday - 格式 'YYYY-MM-DD'
 * @returns {number | null}
 */
export function calculateAge(birthday) {
    if (!birthday) return null;
    const birthDate = new Date(birthday);
    if (isNaN(birthDate.getTime())) return null;

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

/**
 * 判斷今天是否為此人的生日
 * @param {string} birthday - 格式 'YYYY-MM-DD'
 * @returns {boolean}
 */
export function isBirthdayToday(birthday) {
    if (!birthday) return false;
    const birthDate = new Date(birthday);
    if (isNaN(birthDate.getTime())) return false;

    const today = new Date();
    return (
        birthDate.getMonth() === today.getMonth() &&
        birthDate.getDate() === today.getDate()
    );
}
